import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=26b0945b"
import script from "./ActivityForm.vue?vue&type=script&lang=ts"
export * from "./ActivityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports